<template>
<!--hero section start-->
  <v-app>
    <v-container fluid fill-height class="pa-0 gray-bg">
      <v-row no-gutters class="align-items-center justify-content-center fill-height" align="center">
        <v-col class="col-12 col-md-6 col-lg-8  d-none d-md-block fill-height" >
          <!-- Image -->
          <div class="bg-cover background-img fill-height" style="background-image: url(/assets/img/hero-bg-1.jpg);">
            <div class="login-signup-content">
              <div class="col-md-12 col-lg-7">
                  <h2 class="text-white mb-2">Bentornato!</h2>
                  <p class="lead">Quando ero bambino il menù della mia famiglia <br />era composto da due scelte: prendere o lasciare.<br /><br/>
                    <i class="font-italic">Buddy Hackett</i>
                  </p>
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="col-12 col-md-6 col-lg-4">
          <div class="login-signup-wrap px-4 px-lg-5 my-5">
            <!-- Heading -->
            <div v-if="!changePasswd">
              <h1 class="text-center mb-1">
                  Accedi
              </h1>
              <p class="text-center mb-5">
                  Il tuo menù ti aspetta!
              </p>

              <!--login form-->
              <v-form ref="form" v-model="valid">
                <label class="pb-1">
                  Email
                </label>
                <v-text-field
                  v-model="email"
                  placeholder="nome@dominio.com"
                  :rules="notEmptyEmail"
                  solo
                  prepend-inner-icon="email"
                  color="#e94e1b"
                  @keyup.enter="submit"
                >
                </v-text-field>

                <label class="pb-1 d-flex justify-space-between">
                  Password
                  <router-link to="/reset"> Hai dimenticato la password? </router-link>
                </label>
                <v-text-field
                  v-model="password"
                  placeholder="Inserisci la password"
                  :rules="notEmptyPasswd"
                  solo
                  prepend-inner-icon="lock"
                  color="#e94e1b"
                  type="password"
                  @keyup.enter="submit"
                >
                </v-text-field>
                <!-- Submit -->
                <v-btn large block class="submit-btn" :loading="loading" @click="submit">
                    Accedi
                </v-btn>

                <!-- Link -->
                <p class="text-center mt-6">
                    <small class="text-muted text-center">
                        Non hai ancora un account? <router-link to="/signup/free">Registrati</router-link>.
                    </small>
                </p>
                <v-input hidden id="g-recaptcha-response" name="g-recaptcha-response" />
              </v-form>
            </div>
            <div v-else>
              <h1 class="text-center mb-1">
                  Cambia la password
              </h1>
              <p class="text-center mb-5">
                  È la prima volta che accedi su Menubook, modifica la password temporanea
              </p>

              <!--login form-->
              <v-form ref="form" v-model="valid">
                <label class="pb-1">
                  Nuova Password
                </label>
                <v-text-field
                  v-model="newPasswd"
                  placeholder="Inserisci la nuova password"
                  :rules="notEmptyPasswd"
                  solo
                  prepend-inner-icon="lock"
                  color="#e94e1b"
                  type="password"
                  @keyup.enter="submit"
                >
                </v-text-field>

                <label class="pb-1 d-flex justify-space-between">
                  Conferma Password
                </label>
                <v-text-field
                  v-model="confirmPasswd"
                  placeholder="Reinserisci la password"
                  :rules="notEmptyConfirmPasswd"
                  solo
                  prepend-inner-icon="lock"
                  color="#e94e1b"
                  type="password"
                  @keyup.enter="submit"
                >
                </v-text-field>
                <!-- Submit -->
                <v-btn large block class="submit-btn" :loading="loading" @click="submit">
                    Accedi
                </v-btn>

                <!-- Link -->
                <p class="text-center mt-6">
                    <small class="text-muted text-center">
                        Non hai ancora un account? <router-link to="signup/free">Registrati</router-link>.
                    </small>
                </p>
                <input hidden id="g-recaptcha-response" name="g-recaptcha-response" />
              </v-form>
            </div>
          </div>
        </v-col>
      </v-row> <!-- / .row -->
    </v-container>
     <v-snackbar
        v-model="error"
        timeout="2000"
        color="error"
      >Qualcosa è andato storto. Controlla le credenziali che hai inserito
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="error = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
        v-model="success"
        timeout="2000"
        color="successs"
      >{{successMessage}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="error = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<script>
  import { Auth } from 'aws-amplify'

  export default({
    name:"Login",
    data: function(){
      return{
        error:'',
        valid:'',
        email:'',
        password:'',
        loading:false,
        notEmptyEmail: [
          v => !!v || "Inserire  l'username",
          v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Indirizzo non valido.'           
        ],
        notEmptyPasswd: [
          v => !!v || "Inserire la password",
          v => v.length > 7 || "La password deve essere lunga almeno 8 caratteri",
          v => /[0-9]+/.test(v) || "La password deve contenere almeno un numero"
        ],
        notEmptyConfirmPasswd:[
          v => !!v || "Inserire nuovamente la password",
          v => v == this.newPasswd || "Le password non combaciano"
        ],
        changePasswd:false,
        newPasswd:'',
        confirmPasswd:'',
        success:false,
        successMessage:'',
      }
    },
    methods:{
      submit:function(){
        if(this.$refs.form.validate()){
          this.loading=true
          var self = this
          //eslint-disable-next-line
          Auth.signIn(this.email,this.password)
          .then(user =>{
            if(user.challengeName === 'NEW_PASSWORD_REQUIRED'){
              if(!self.changePasswd ){
                //first access change password
                self.changePasswd=true
                self.loading=false
              }
              else{
                //eslint-disable-next-line
                Auth.completeNewPassword(user,self.newPasswd).then(user=>{
                  self.loading=false
                  self.password = self.newPasswd
                  self.success=true
                  self.successMessage="Password aggiornata"
                  self.submit()
                  console.log(user)
                })
                .catch(error=>{
                  console.log(error)
                  this.error=true
                  self.loading=false
                })
              }
            }
            else{
              console.log(user)
              self.$store.commit('setUser',self.email)
              self.$store.commit('setAccessToken',user.signInUserSession.accessToken.jwtToken)
              self.$store.commit('setIdToken',user.signInUserSession.idToken.jwtToken)
              self.$store.commit('setAttributes',JSON.stringify(user.attributes))
              //TODO location.href
              window.location.href='/adminmenu.html'
            }
          })
          //eslint-disable-next-line
          .catch(error => {
            console.log(error)
            this.error = true
            self.loading = false
          })
        }
      },
    }
  })
</script>
<style>
.background-img{
    position: relative;
    width: 100%;
    display: block;
    background-size: cover;
    background-position: center;
}
.background-img:before{
    position: absolute;
    content: '';
    background-color: rgba(233, 78, 27, 0.62);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.gray-bg{
  background-color:#f4f7fa
}

/*login css*/
.login-signup-content{
    height: 100%;
    width: 100%;
    z-index: 1;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    color:#fff;
    position: absolute;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.75
}

.login-signup-content h2{
  font-size:2.5em;
  line-height: 1.21;
}
.login-signup-content .lead{
  font-size:1.25em
}
label{
  font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 88%;
}

.v-input__slot{
  border-color: #e94e1b !important;
  border-style: solid;
  border-width: 0 0 0 2px;
}

.submit-btn{
  background-color: #e94e1b !important;
  color: #fff !important;
}

</style>